import { render, staticRenderFns } from "./AccountmingxiRight.vue?vue&type=template&id=d6aadb5e&scoped=true"
import script from "./AccountmingxiRight.vue?vue&type=script&lang=js"
export * from "./AccountmingxiRight.vue?vue&type=script&lang=js"
import style0 from "./AccountmingxiRight.vue?vue&type=style&index=0&id=d6aadb5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6aadb5e",
  null
  
)

export default component.exports